// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"aec3e412","224":"e984732b","306":"a5465d7f","352":"4612def6","488":"ca5aaf67","765":"5d0257a3"}[chunkId] + ".chunk.js";
};